<template>
    <div id="data-list-list-view" class="data-list-container">

        <vs-table
                ref="table"
                :max-items="itemsPerPage"
                search
                :data="payment_upload"
        >
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                    <template v-if="this.$store.state.is_admin() || this.$store.state.is_chargerClientele()">
                        <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                        >
                            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                            <span class="ml-2 text-base text-primary" @click="activePrompt = true" >Nouvel upload</span>
                        </div>
                        <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                        >
                            <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" />
                            <span class="ml-2 text-base text-primary" @click="downloadSample">Télécharger le fichier exemple</span>
                        </div>
                    </template>
                    <vs-prompt
                            title="Nouvel Upload de facture"
                            accept-text= "Uploader"
                            button-cancel = "border"
                            @accept="submitForm"
                            @cancel="cancelUpload"
                            cancel-text="Annuler"
                            :active.sync="activePrompt">
                        <form>
                            <div class="vx-row">
                                <div class="vx-col w-full">
                                    <vs-input name="Nom"
                                              :danger="errnos.name ? true : false"
                                              :danger-text="errnos.name ? errnos.name[0] : ''"
                                              label="Nom" class="w-full mb-4 mt-5"
                                              placeholder="Nom" v-model="name" />
                                </div>
                                <div class="vx-col w-full">
                                    <input type="file" class="hidden"
                                           ref="uploadFileInput" @change="updateFile"
                                           :danger="errnos.file ? true : false"
                                           :danger-text="errnos.file ? errnos.file[0] : ''"
                                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                                    <vs-button class="mr-4 mb-4" @click="$refs.uploadFileInput.click()">Choisir un fichier</vs-button> <span>{{ fileName ? fileName.name : '' }}</span><br>
                                    <span v-if="errnos.file" style="color: #EA5455">{{ errnos.file ? errnos.file[0] : '' }}</span>
                                </div>
                            </div>
                        </form>
                    </vs-prompt>
                </div>

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="itemsPerPage = 4">
                            <span>4</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage = 10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage = 15">
                            <span>15</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage = 20">
                            <span>20</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>

            </div>

            <template slot="thead">
                <vs-th sort-key="upload">Upload</vs-th>
                <vs-th sort-key="date">Date</vs-th>
                <vs-th sort-key="invoices">Factures</vs-th>
                <vs-th sort-key="total">Total</vs-th>
                <vs-th sort-key="author">Auteur</vs-th>
                <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <span class="font-semibold">{{ tr.name }}</span>
                    </vs-td>
                    <vs-td>
                        <span>{{ tr.created_at }}</span>
                    </vs-td>
                    <vs-td>
                        <span>{{ tr.total_payment }}</span>
                    </vs-td>
                    <vs-td>
                        <span class="font-semibold">{{ tr.total_amount}} F CFA</span>
                    </vs-td>
                    <vs-td>
                        <span>{{ tr.author }}</span>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                        <div class="flex">
                            <vx-tooltip text="Voir les factures">
                                <feather-icon
                                        icon="FileTextIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                        class="mr-2"
                                        @click="showDetails(tr.id)"
                                />
                            </vx-tooltip>
                            <template v-if="is_authorize()">
                                <vx-tooltip text="Supprimer">
                                    <feather-icon
                                            icon="TrashIcon"
                                            svgClasses="w-5 h-5 text-danger stroke-current"
                                            class="mr-2"
                                            @click="deleteUpload(tr)"
                                    />
                                </vx-tooltip>
                            </template>
                        </div>
                    </vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activePrompt: false,
                itemsPerPage: 8,
                isMounted: false,
                showSidebar: false,
                sidebarData: {},
                fileName: null,
                name: '',
                payment_upload: [],
                errnos: [],
                last_page: 1,
                page: 1,
            }
        },
        computed: {
            isAdmin() {
                return this.$store.state.AppActiveUser.userRole !== 'client'
            },
        },
        mounted() {
            this.isMounted = true;
            this.uploadList()
        },
        methods: {
            toggleDataSidebar(val = false) {
                this.showSidebar = val;
            },
            is_authorize(){
                if(this.$store.state.is_admin() || this.$store.state.is_chargerClientele()){
                    return true;
                }
                return false;
            },
            showDetails(id) {
                let el = '/payments/'+id+'/detail';
                this.$router.push(el);
            },
            cancelUpload(){
                this.errnos = []
                this.fileName = null
                this.activePrompt = false
            },
            downloadSample() {
                this.$vs.loading()
                this.$http.get('/payments/download', {
                    responseType: 'blob',
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'sample_payment.xlsx')
                    document.body.appendChild(link)
                    this.$vs.loading.close()
                    link.click()
                }).catch((error) => {
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                        this.$router.push('/login')
                    }
                })
            },
            submitForm() {
                if (this.fileName){
                    this.$vs.loading()
                    let formData = new FormData()
                    formData.append('file', this.fileName)
                    formData.append('name', this.name)
                    this.$http.post('/payments/import', formData).then((response) => {
                        let id = response.data.id
                        this.cancelUpload()
                        if (id){
                            this.$router.push({name: 'ResultsPaymentUpload', params:{id: id}})
                        }else window.GETCCMT.notification('danger','Erreur','Une erreur est survenu');
                        this.$vs.loading.close()
                    }).catch((error) => {
                        this.$vs.loading.close()
                        if (error.response.status === 401){
                            this.$router.push('/login')
                        }else  this.errnos = error.response.data.errors
                    })
                }else {
                    window.GETCCMT.notification('danger','Erreur','Veuillez selectionner un fichier');
                }
                this.activePrompt = true
                //this.$router.push('/uploads/invoices/results');
            },
            updateFile(input) {
                if (input.target.files && input.target.files[0]) {
                    this.fileName = input.target.files[0];
                }
            },
            uploadList(){
                this.$vs.loading()
                this.$http.get('/payments/upload/list?page='+this.page).then((response) => {
                    this.payment_upload = response.data.data
                    this.last_page = response.data.last_page
                    this.$vs.loading.close()
                }).catch((error) =>{
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                        this.$router.push('/login')
                    }
                })
            },
            deleteUpload(el) {
                if (confirm('Voulez vous vraiment supprimer ?')){
                    this.$vs.loading()
                    this.$http.post('/bills/upload/delete', {id: el.id}).then((response) => {
                        if (response.data.status){
                            let index = this.payment_upload.indexOf(el)
                            this.payment_upload.splice(index, 1)
                            window.GETCCMT.notification('success','Suppression','Opération effectuée');
                        }
                        this.$vs.loading.close()
                    }).catch((error) =>{
                        this.$vs.loading.close()
                        if (error.response.status === 401){
                            this.$router.push('/login')
                        }
                    })
                }
            },

        }
    }
</script>

<style lang="scss">
    #data-list-list-view {
        .vs-con-table {
            @media (max-width: 689px) {
                .vs-table--search {
                    margin-left: 0;
                    max-width: unset;
                    width: 100%;

                    .vs-table--search-input {
                        width: 100%;
                    }
                }
            }

            @media (max-width: 461px) {
                .items-per-page-handler {
                    display: none;
                }
            }

            @media (max-width: 341px) {
                .data-list-btn-container {
                    width: 100%;

                    .dd-actions,
                    .btn-add-new {
                        width: 100%;
                        margin-right: 0 !important;
                    }
                }
            }

            .product-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap;
                margin-left: 1.5rem;
                margin-right: 1.5rem;
                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                    td {
                        padding: 20px;
                        &:first-child {
                            border-top-left-radius: 0.5rem;
                            border-bottom-left-radius: 0.5rem;
                        }
                        &:last-child {
                            border-top-right-radius: 0.5rem;
                            border-bottom-right-radius: 0.5rem;
                        }
                    }
                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }
                th.td-check {
                    padding: 0 15px !important;
                }
                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>